import StringUtils from 'utils/platform/string_utils.js'

;jQuery(document).ready(function($) {

  var $flash = $("#flash"), timeout = false;

  contently.flash = {
    show: function(type, message, autoclose) {
      autoclose = typeof autoclose !== 'undefined' ? autoclose : true;
      var escapedMessage = StringUtils.escapeHTML(message, ["br", "var"]);
      var $contents = $("<div>", { class: "notification-flash animate " + type });
      var $innerHtml = $("<div>", { class: "flash-content" }).html(escapedMessage);
      $contents.append($innerHtml);
      $flash.html($contents);
      $flash.removeClass("hidden begone");
      if (autoclose) { this.autoclose(); }
    },

    working: function(message) {
      this.show("working", message || "Loading...");
    },

    close: function(event) {
      if (!!event) { event.preventDefault(); }

      $flash
        .addClass("begone")
        .delay(500)
        .queue(function(){
          $flash.addClass("hidden").dequeue();
        });

      if (timeout) { clearTimeout(timeout)}
    },

    autoclose: function() {
      timeout = setTimeout(contently.flash.close, 5000);
    }
  };

  // Adding convenience accessors for different message types
  $.each(["alert", "notice", "success", "info"], function() {
    var type = this.toString();
    contently.flash[type] = function (message) {
      contently.flash.show(type, message, (type !== "alert"));
    };
  });

  $flash.on("click", function(e){
    if(e.target.tagName != "A"){
      contently.flash.close(e)
    }
  });

});

(function($, document) {

  // var currentRequests = 0;
  // $(document).ajaxStart(function (event, jqXhr, opts) {
  //   currentRequests++;
  //   contently.flash.working();
  // });

  $(document).ajaxComplete(function (event, jqXhr, opts) {
    // currentRequests--;
    // if (currentRequests == 0) { contently.flash.close(); }

    var type = jqXhr.getResponseHeader("X-Message-Type") || "notice";
    var message = jqXhr.getResponseHeader("X-Message");

    if (!!message) {
      if (!!contently.flash[type]) {
        contently.flash[type](message);
      }
      else {
        console.log("Error, flash type \"" + type + "\" not supported.")
      }
    }

  });

})(jQuery, document);



// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/jquery.global-ajax-flash.js